/**
 * This file is auto-generated
 */
export var OrgEmailPlatform;
(function (OrgEmailPlatform) {
    OrgEmailPlatform[OrgEmailPlatform["MICROSOFT"] = 0] = "MICROSOFT";
    OrgEmailPlatform[OrgEmailPlatform["GOOGLE"] = 1] = "GOOGLE";
    OrgEmailPlatform[OrgEmailPlatform["OTHER"] = 2] = "OTHER";
})(OrgEmailPlatform || (OrgEmailPlatform = {}));
export const organizationApiMethods = [
    'getOrganizationsList',
    'removeOrganization',
    'createOrganization',
    'setDefaultOrganization',
];
//# sourceMappingURL=organization-api.js.map